import { Route, Routes } from "react-router-dom";

import { ProtectedRoute } from "@/app/(protected)/protected-route";
import TeamLeaderLayout from "@/app/(protected)/teamleader/layout";
import TeamLeaderTodayPage from "@/app/(protected)/teamleader/page";
import TeamLeaderSummaryPage from "@/app/(protected)/teamleader/summary/page";
import TeamLeaderAttendancePage from "@/app/(protected)/teamleader/attendance/page";

const TeamLeaderRoutes = () => {
  return (
    <Routes>
      <Route element={<ProtectedRoute />}>
        <Route element={<TeamLeaderLayout />}>
          <Route index path="/" element={<TeamLeaderTodayPage />} />
          <Route path="/summary" element={<TeamLeaderSummaryPage />} />
          <Route path="/attendance" element={<TeamLeaderAttendancePage />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default TeamLeaderRoutes;
